module.exports = __webpack_public_path__ + "img/PaidOutlined.eeaa753a.svg";